/**
 * Workspace tabs stay four destinations. Visual grouping makes Cases the
 * operational home and Scans/Records secondary measurement/history.
 */

export const WORKSPACE_NAV_GROUPS = [
  {
    id: 'work',
    label: 'Work',
    helper: 'Action required | Safety Cases',
    tabs: ['attention', 'cases'] as const,
  },
  {
    id: 'measurement',
    label: 'Measurement & history',
    helper: 'Safety Scans | Signed Records',
    tabs: ['scans', 'records'] as const,
  },
] as const;

export type WorkspaceNavGroupId = (typeof WORKSPACE_NAV_GROUPS)[number]['id'];
export type WorkspaceNavTab = (typeof WORKSPACE_NAV_GROUPS)[number]['tabs'][number];

export function workspaceNavGroupForTab(tab: string): (typeof WORKSPACE_NAV_GROUPS)[number] {
  return WORKSPACE_NAV_GROUPS.find((group) => (group.tabs as readonly string[]).includes(tab))
    || WORKSPACE_NAV_GROUPS[0];
}
